module.exports = __webpack_public_path__ + "img/sieckFinesseSwing2.f440b9c2.png";